/**
 * @fileoverview gRPC-Web generated client stub for io.codedrills.proto.user
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var io_codedrills_proto_user_user_pb = require('../../../../io/codedrills/proto/user/user_pb.js')

var io_codedrills_proto_content_content_pb = require('../../../../io/codedrills/proto/content/content_pb.js')

var io_codedrills_proto_content_preview_pb = require('../../../../io/codedrills/proto/content/preview_pb.js')

var io_codedrills_proto_user_dashboard_pb = require('../../../../io/codedrills/proto/user/dashboard_pb.js')
const proto = {};
proto.io = {};
proto.io.codedrills = {};
proto.io.codedrills.proto = {};
proto.io.codedrills.proto.user = require('./user_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.user.UserServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.user.UserServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.RegisterUserRequest,
 *   !proto.io.codedrills.proto.user.RegisterUserResponse>}
 */
const methodInfo_UserService_RegisterUser = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.RegisterUserResponse,
  /** @param {!proto.io.codedrills.proto.user.RegisterUserRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.RegisterUserResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.RegisterUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.RegisterUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.RegisterUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.registerUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/RegisterUser',
      request,
      metadata || {},
      methodInfo_UserService_RegisterUser,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.RegisterUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.RegisterUserResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.registerUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/RegisterUser',
      request,
      metadata || {},
      methodInfo_UserService_RegisterUser);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetProfileRequest,
 *   !proto.io.codedrills.proto.user.GetProfileResponse>}
 */
const methodInfo_UserService_GetProfile = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetProfileResponse,
  /** @param {!proto.io.codedrills.proto.user.GetProfileRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetProfileResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.getProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetProfile',
      request,
      metadata || {},
      methodInfo_UserService_GetProfile,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetProfileResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.getProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetProfile',
      request,
      metadata || {},
      methodInfo_UserService_GetProfile);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetPublicProfileRequest,
 *   !proto.io.codedrills.proto.user.GetPublicProfileResponse>}
 */
const methodInfo_UserService_GetPublicProfile = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetPublicProfileResponse,
  /** @param {!proto.io.codedrills.proto.user.GetPublicProfileRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetPublicProfileResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetPublicProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetPublicProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetPublicProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.getPublicProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetPublicProfile',
      request,
      metadata || {},
      methodInfo_UserService_GetPublicProfile,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetPublicProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetPublicProfileResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.getPublicProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetPublicProfile',
      request,
      metadata || {},
      methodInfo_UserService_GetPublicProfile);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.EditProfileRequest,
 *   !proto.io.codedrills.proto.user.EditProfileResponse>}
 */
const methodInfo_UserService_EditProfile = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.EditProfileResponse,
  /** @param {!proto.io.codedrills.proto.user.EditProfileRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.EditProfileResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.EditProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.EditProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.EditProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.editProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/EditProfile',
      request,
      metadata || {},
      methodInfo_UserService_EditProfile,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.EditProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.EditProfileResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.editProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/EditProfile',
      request,
      metadata || {},
      methodInfo_UserService_EditProfile);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.UploadUserImageRequest,
 *   !proto.io.codedrills.proto.user.UploadUserImageResponse>}
 */
const methodInfo_UserService_UploadUserImage = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.UploadUserImageResponse,
  /** @param {!proto.io.codedrills.proto.user.UploadUserImageRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.UploadUserImageResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.UploadUserImageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.UploadUserImageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.UploadUserImageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.uploadUserImage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/UploadUserImage',
      request,
      metadata || {},
      methodInfo_UserService_UploadUserImage,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.UploadUserImageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.UploadUserImageResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.uploadUserImage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/UploadUserImage',
      request,
      metadata || {},
      methodInfo_UserService_UploadUserImage);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.VerifyCpProfileRequest,
 *   !proto.io.codedrills.proto.user.VerifyCpProfileResponse>}
 */
const methodInfo_UserService_VerifyCpProfile = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.VerifyCpProfileResponse,
  /** @param {!proto.io.codedrills.proto.user.VerifyCpProfileRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.VerifyCpProfileResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.VerifyCpProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.VerifyCpProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.VerifyCpProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.verifyCpProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/VerifyCpProfile',
      request,
      metadata || {},
      methodInfo_UserService_VerifyCpProfile,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.VerifyCpProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.VerifyCpProfileResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.verifyCpProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/VerifyCpProfile',
      request,
      metadata || {},
      methodInfo_UserService_VerifyCpProfile);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetUsersRequest,
 *   !proto.io.codedrills.proto.user.GetUsersResponse>}
 */
const methodInfo_UserService_GetUsers = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetUsersResponse,
  /** @param {!proto.io.codedrills.proto.user.GetUsersRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetUsersResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.getUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetUsers',
      request,
      metadata || {},
      methodInfo_UserService_GetUsers,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetUsersResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.getUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetUsers',
      request,
      metadata || {},
      methodInfo_UserService_GetUsers);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.UpdateUserRequest,
 *   !proto.io.codedrills.proto.user.UpdateUserResponse>}
 */
const methodInfo_UserService_UpdateUser = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.UpdateUserResponse,
  /** @param {!proto.io.codedrills.proto.user.UpdateUserRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.UpdateUserResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.UpdateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.UpdateUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.UpdateUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.updateUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/UpdateUser',
      request,
      metadata || {},
      methodInfo_UserService_UpdateUser,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.UpdateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.UpdateUserResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.updateUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/UpdateUser',
      request,
      metadata || {},
      methodInfo_UserService_UpdateUser);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetAuthProfileRequest,
 *   !proto.io.codedrills.proto.user.GetAuthProfileResponse>}
 */
const methodInfo_UserService_GetAuthProfile = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetAuthProfileResponse,
  /** @param {!proto.io.codedrills.proto.user.GetAuthProfileRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetAuthProfileResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetAuthProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetAuthProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetAuthProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.getAuthProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetAuthProfile',
      request,
      metadata || {},
      methodInfo_UserService_GetAuthProfile,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetAuthProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetAuthProfileResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.getAuthProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetAuthProfile',
      request,
      metadata || {},
      methodInfo_UserService_GetAuthProfile);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetBasicProfileRequest,
 *   !proto.io.codedrills.proto.user.GetBasicProfileResponse>}
 */
const methodInfo_UserService_GetBasicProfile = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetBasicProfileResponse,
  /** @param {!proto.io.codedrills.proto.user.GetBasicProfileRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetBasicProfileResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetBasicProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetBasicProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetBasicProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.getBasicProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetBasicProfile',
      request,
      metadata || {},
      methodInfo_UserService_GetBasicProfile,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetBasicProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetBasicProfileResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.getBasicProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetBasicProfile',
      request,
      metadata || {},
      methodInfo_UserService_GetBasicProfile);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.UpdateUserScopeAndRoleRequest,
 *   !proto.io.codedrills.proto.user.UpdateUserScopeAndRoleResponse>}
 */
const methodInfo_UserService_UpdateUserScopeAndRole = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.UpdateUserScopeAndRoleResponse,
  /** @param {!proto.io.codedrills.proto.user.UpdateUserScopeAndRoleRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.UpdateUserScopeAndRoleResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.UpdateUserScopeAndRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.UpdateUserScopeAndRoleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.UpdateUserScopeAndRoleResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.updateUserScopeAndRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/UpdateUserScopeAndRole',
      request,
      metadata || {},
      methodInfo_UserService_UpdateUserScopeAndRole,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.UpdateUserScopeAndRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.UpdateUserScopeAndRoleResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.updateUserScopeAndRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/UpdateUserScopeAndRole',
      request,
      metadata || {},
      methodInfo_UserService_UpdateUserScopeAndRole);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.UpdateUserPreferenceRequest,
 *   !proto.io.codedrills.proto.user.UpdateUserPreferenceResponse>}
 */
const methodInfo_UserService_UpdateUserPreference = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.UpdateUserPreferenceResponse,
  /** @param {!proto.io.codedrills.proto.user.UpdateUserPreferenceRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.UpdateUserPreferenceResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.UpdateUserPreferenceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.UpdateUserPreferenceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.UpdateUserPreferenceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.updateUserPreference =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/UpdateUserPreference',
      request,
      metadata || {},
      methodInfo_UserService_UpdateUserPreference,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.UpdateUserPreferenceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.UpdateUserPreferenceResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.updateUserPreference =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/UpdateUserPreference',
      request,
      metadata || {},
      methodInfo_UserService_UpdateUserPreference);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetUserPreferenceRequest,
 *   !proto.io.codedrills.proto.user.GetUpdateUserPreferenceResponse>}
 */
const methodInfo_UserService_GetUserPreference = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetUpdateUserPreferenceResponse,
  /** @param {!proto.io.codedrills.proto.user.GetUserPreferenceRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetUpdateUserPreferenceResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetUserPreferenceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetUpdateUserPreferenceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetUpdateUserPreferenceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.getUserPreference =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetUserPreference',
      request,
      metadata || {},
      methodInfo_UserService_GetUserPreference,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetUserPreferenceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetUpdateUserPreferenceResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.getUserPreference =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetUserPreference',
      request,
      metadata || {},
      methodInfo_UserService_GetUserPreference);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.Activity,
 *   !proto.io.codedrills.proto.user.Activity>}
 */
const methodInfo_UserService_CreateUserActivity = new grpc.web.AbstractClientBase.MethodInfo(
  io_codedrills_proto_user_user_pb.Activity,
  /** @param {!proto.io.codedrills.proto.user.Activity} request */
  function(request) {
    return request.serializeBinary();
  },
  io_codedrills_proto_user_user_pb.Activity.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.Activity} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.Activity)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.Activity>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.createUserActivity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/CreateUserActivity',
      request,
      metadata || {},
      methodInfo_UserService_CreateUserActivity,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.Activity} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.Activity>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.createUserActivity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/CreateUserActivity',
      request,
      metadata || {},
      methodInfo_UserService_CreateUserActivity);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetUserActivityRequest,
 *   !proto.io.codedrills.proto.user.GetUserActivityResponse>}
 */
const methodInfo_UserService_GetUserActivity = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetUserActivityResponse,
  /** @param {!proto.io.codedrills.proto.user.GetUserActivityRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetUserActivityResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetUserActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetUserActivityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetUserActivityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.getUserActivity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetUserActivity',
      request,
      metadata || {},
      methodInfo_UserService_GetUserActivity,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetUserActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetUserActivityResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.getUserActivity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetUserActivity',
      request,
      metadata || {},
      methodInfo_UserService_GetUserActivity);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetContentUserActivityRequest,
 *   !proto.io.codedrills.proto.user.GetContentUserActivityResponse>}
 */
const methodInfo_UserService_GetContentUserActivity = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetContentUserActivityResponse,
  /** @param {!proto.io.codedrills.proto.user.GetContentUserActivityRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetContentUserActivityResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetContentUserActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetContentUserActivityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetContentUserActivityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.getContentUserActivity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetContentUserActivity',
      request,
      metadata || {},
      methodInfo_UserService_GetContentUserActivity,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetContentUserActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetContentUserActivityResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.getContentUserActivity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetContentUserActivity',
      request,
      metadata || {},
      methodInfo_UserService_GetContentUserActivity);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetDashboardRequest,
 *   !proto.io.codedrills.proto.user.GetDashboardResponse>}
 */
const methodInfo_UserService_GetDashboard = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetDashboardResponse,
  /** @param {!proto.io.codedrills.proto.user.GetDashboardRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetDashboardResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetDashboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetDashboardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetDashboardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.getDashboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetDashboard',
      request,
      metadata || {},
      methodInfo_UserService_GetDashboard,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetDashboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetDashboardResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.getDashboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetDashboard',
      request,
      metadata || {},
      methodInfo_UserService_GetDashboard);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.SetTrackingStatusRequest,
 *   !proto.io.codedrills.proto.user.SetTrackingStatusResponse>}
 */
const methodInfo_UserService_SetTrackingStatus = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.SetTrackingStatusResponse,
  /** @param {!proto.io.codedrills.proto.user.SetTrackingStatusRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.SetTrackingStatusResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.SetTrackingStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.SetTrackingStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.SetTrackingStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.setTrackingStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/SetTrackingStatus',
      request,
      metadata || {},
      methodInfo_UserService_SetTrackingStatus,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.SetTrackingStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.SetTrackingStatusResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.setTrackingStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/SetTrackingStatus',
      request,
      metadata || {},
      methodInfo_UserService_SetTrackingStatus);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.ValidateSSORequest,
 *   !proto.io.codedrills.proto.user.ValidateSSOResponse>}
 */
const methodInfo_UserService_ValidateSSO = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.ValidateSSOResponse,
  /** @param {!proto.io.codedrills.proto.user.ValidateSSORequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.ValidateSSOResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.ValidateSSORequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.ValidateSSOResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.ValidateSSOResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.validateSSO =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/ValidateSSO',
      request,
      metadata || {},
      methodInfo_UserService_ValidateSSO,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.ValidateSSORequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.ValidateSSOResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.validateSSO =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/ValidateSSO',
      request,
      metadata || {},
      methodInfo_UserService_ValidateSSO);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetUserPreviewsRequest,
 *   !proto.io.codedrills.proto.user.GetUserPreviewsResponse>}
 */
const methodInfo_UserService_GetUserPreviews = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetUserPreviewsResponse,
  /** @param {!proto.io.codedrills.proto.user.GetUserPreviewsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetUserPreviewsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetUserPreviewsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetUserPreviewsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetUserPreviewsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.getUserPreviews =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetUserPreviews',
      request,
      metadata || {},
      methodInfo_UserService_GetUserPreviews,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetUserPreviewsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetUserPreviewsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.getUserPreviews =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetUserPreviews',
      request,
      metadata || {},
      methodInfo_UserService_GetUserPreviews);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.IsAdminRequest,
 *   !proto.io.codedrills.proto.user.IsAdminResponse>}
 */
const methodInfo_UserService_IsAdmin = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.IsAdminResponse,
  /** @param {!proto.io.codedrills.proto.user.IsAdminRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.IsAdminResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.IsAdminRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.IsAdminResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.IsAdminResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.isAdmin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/IsAdmin',
      request,
      metadata || {},
      methodInfo_UserService_IsAdmin,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.IsAdminRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.IsAdminResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.isAdmin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/IsAdmin',
      request,
      metadata || {},
      methodInfo_UserService_IsAdmin);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetSubscriptionSettingsRequest,
 *   !proto.io.codedrills.proto.user.GetSubscriptionSettingsResponse>}
 */
const methodInfo_UserService_GetUserSubscriptionSettings = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetSubscriptionSettingsResponse,
  /** @param {!proto.io.codedrills.proto.user.GetSubscriptionSettingsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetSubscriptionSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetSubscriptionSettingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetSubscriptionSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetSubscriptionSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.getUserSubscriptionSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetUserSubscriptionSettings',
      request,
      metadata || {},
      methodInfo_UserService_GetUserSubscriptionSettings,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetSubscriptionSettingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetSubscriptionSettingsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.getUserSubscriptionSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetUserSubscriptionSettings',
      request,
      metadata || {},
      methodInfo_UserService_GetUserSubscriptionSettings);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.UpdateSubscriptionSettingsRequest,
 *   !proto.io.codedrills.proto.user.UpdateSubscriptionSettingsResponse>}
 */
const methodInfo_UserService_UpdateUserSubscriptionSettings = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.UpdateSubscriptionSettingsResponse,
  /** @param {!proto.io.codedrills.proto.user.UpdateSubscriptionSettingsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.UpdateSubscriptionSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.UpdateSubscriptionSettingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.UpdateSubscriptionSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.UpdateSubscriptionSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.updateUserSubscriptionSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/UpdateUserSubscriptionSettings',
      request,
      metadata || {},
      methodInfo_UserService_UpdateUserSubscriptionSettings,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.UpdateSubscriptionSettingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.UpdateSubscriptionSettingsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.updateUserSubscriptionSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/UpdateUserSubscriptionSettings',
      request,
      metadata || {},
      methodInfo_UserService_UpdateUserSubscriptionSettings);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetCustomerIdRequest,
 *   !proto.io.codedrills.proto.user.GetCustomerIdResponse>}
 */
const methodInfo_UserService_GetCustomerId = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetCustomerIdResponse,
  /** @param {!proto.io.codedrills.proto.user.GetCustomerIdRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetCustomerIdResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetCustomerIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetCustomerIdResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetCustomerIdResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.getCustomerId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetCustomerId',
      request,
      metadata || {},
      methodInfo_UserService_GetCustomerId,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetCustomerIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetCustomerIdResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.getCustomerId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetCustomerId',
      request,
      metadata || {},
      methodInfo_UserService_GetCustomerId);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.Empty,
 *   !proto.io.codedrills.proto.user.Empty>}
 */
const methodInfo_UserService_UpdateProblemSolved = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.Empty,
  /** @param {!proto.io.codedrills.proto.user.Empty} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.Empty.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.updateProblemSolved =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/UpdateProblemSolved',
      request,
      metadata || {},
      methodInfo_UserService_UpdateProblemSolved,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.Empty>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.updateProblemSolved =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/UpdateProblemSolved',
      request,
      metadata || {},
      methodInfo_UserService_UpdateProblemSolved);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetUsersWithScopeRequest,
 *   !proto.io.codedrills.proto.user.GetUsersWithScopeResponse>}
 */
const methodInfo_UserService_GetUsersWithScope = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetUsersWithScopeResponse,
  /** @param {!proto.io.codedrills.proto.user.GetUsersWithScopeRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetUsersWithScopeResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetUsersWithScopeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetUsersWithScopeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetUsersWithScopeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.getUsersWithScope =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetUsersWithScope',
      request,
      metadata || {},
      methodInfo_UserService_GetUsersWithScope,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetUsersWithScopeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetUsersWithScopeResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.getUsersWithScope =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetUsersWithScope',
      request,
      metadata || {},
      methodInfo_UserService_GetUsersWithScope);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetAllRegisteredMembersRequest,
 *   !proto.io.codedrills.proto.user.GetAllRegisteredMembersResponse>}
 */
const methodInfo_UserService_GetAllRegisteredMembers = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetAllRegisteredMembersResponse,
  /** @param {!proto.io.codedrills.proto.user.GetAllRegisteredMembersRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetAllRegisteredMembersResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetAllRegisteredMembersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetAllRegisteredMembersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetAllRegisteredMembersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.UserServiceClient.prototype.getAllRegisteredMembers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetAllRegisteredMembers',
      request,
      metadata || {},
      methodInfo_UserService_GetAllRegisteredMembers,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetAllRegisteredMembersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetAllRegisteredMembersResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.UserServicePromiseClient.prototype.getAllRegisteredMembers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.UserService/GetAllRegisteredMembers',
      request,
      metadata || {},
      methodInfo_UserService_GetAllRegisteredMembers);
};


module.exports = proto.io.codedrills.proto.user;

